import React from 'react'
import './TableUsers.scss'
import { map } from 'lodash';
import Button from '@mui/material/Button';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Close, Check,  Edit, Delete  } from '@mui/icons-material';





  
  export function TableUsers(props) {

    const {users, updateUser, onDeleteUser} = props;
    //console.log(users)
    return (
    <div>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>First Name</TableCell>
            <TableCell>Last Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Is Active</TableCell>
            <TableCell>Is Staff</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {map(users, (user, index) => (
            <TableRow key={index}>
              <TableCell>{user.id}</TableCell>
              <TableCell>{user.username}</TableCell>
              <TableCell>{user.first_name}</TableCell>
              <TableCell>{user.last_name}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.is_active ? <Check /> : <Close />}</TableCell>
              <TableCell>{user.is_staff ? <Check /> : <Close />}</TableCell>
              <ActionsTable user={user} updateUser={updateUser} onDeleteUser={onDeleteUser}/>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>   
  
    </div>
    )
  }


  function ActionsTable(props){
    const {user, updateUser, onDeleteUser} = props;

    return(
        <TableCell>
            <Button onClick={()=> {updateUser(user)}}>
                <Edit />
            </Button>
            <Button onClick={()=> {onDeleteUser(user);}}>
                <Delete />
            </Button>
        </TableCell>
    )


  }






